import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import AddNewTeam from "./components/AddNewTeam/AddNewTeam";
import urls from "../../global/constants/UrlConstants";
import { store } from "../../utils/store";
import { selectUserId } from "../../redux/authSlice";
import {
  cacheProjectForEdit,
  readCachedProjectForEdit,
} from "./projectEditCache";

type RouteProps = {
  match?: { params?: { id?: string } };
  location?: { pathname?: string };
};

/** Resolve edit id from every possible source (hooks, match, pathname) */
const resolveProjectId = (
  hookId: string | undefined,
  matchId: string | undefined,
  pathname: string
) => {
  if (hookId) return String(hookId);
  if (matchId) return String(matchId);
  const m = pathname.match(/\/project\/create\/([^/?#]+)/);
  return m?.[1] ? decodeURIComponent(m[1]) : "";
};

const CreateProject = (props: RouteProps) => {
  const history = useHistory();
  const location = useLocation<{ projectData?: any }>();
  const hookParams = useParams<{ id?: string }>();
  const pathname = location.pathname || props.location?.pathname || window.location.pathname;
  const id = resolveProjectId(
    hookParams?.id,
    props.match?.params?.id,
    pathname
  );
  const userIdFromRedux = selectUserId(store.getState()) || "";
  const [idd, setIdd] = useState<string>(id);

  const projectData = useMemo(() => {
    if (location.state?.projectData) {
      cacheProjectForEdit(
        id || location.state.projectData._id,
        location.state.projectData
      );
      return location.state.projectData;
    }
    return readCachedProjectForEdit(id);
  }, [id, location.state]);

  useEffect(() => {
    setIdd(id);
  }, [id]);

  const isEdit = Boolean(id || idd);

  return (
    <div className="flex h-[calc(100vh-68px)] max-h-[calc(100vh-68px)] flex-col overflow-hidden bg-white">
      <AddNewTeam
        mode="page"
        isDialogOpen={true}
        handleCloseAddTeam={() => history.push(urls.PROJECTS)}
        userId={String(userIdFromRedux || "")}
        idd={id || idd}
        setIdd={setIdd}
        data={isEdit ? projectData || undefined : undefined}
        tableDataShowHandler={() => {}}
      />
    </div>
  );
};

export default CreateProject;
